export const  renderlinkcss = (link) =>{
    var dom=document.createElement('link');
    dom.type='text/css';
    dom.rel="stylesheet";
    dom.href=link;
    document.getElementsByTagName('head')[0].appendChild(dom)
  }


export const getQueryVariable=(variable)=>
{
       var query = window.location.hash.split("?")[1];
       if(!query) return false
       var vars = query.split("&");
       for (var i=0;i<vars.length;i++) {
               var pair = vars[i].split("=");
               if(pair[0] == variable){return decodeURIComponent(pair[1]);}
       }
       return(false);
}